import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import {
 updateSchemeBankAccountApproval, get_departments, get_schemes, getSchemeAccountBalances,AddSchemeBankAccount
} from '../../../helper/Api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Col, Container, Row } from 'react-bootstrap'
import SchemeAccountPreview from '../Model/schemeAccountPreview';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
} from "@mui/material";
import Spinner from '../../Tools/spinner';
const AddSchemeAccount = () => {
    const [loading, setLoading] = useState(false);
    const { id, viewId } = useParams();
    const isReadOnly = viewId;
    const { authData } = useSelector((state) => state.authData);
    const [department, setDepartment] = useState([]);
    const [scheme, setScheme] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
    const [formData, setFormData] = useState({
        "department_id": "",
        "scheme_id": "",
        "account_id": "",
        "l2_approval": "",
        "l3_approval": "",
        "l1_remark": "",
        "l2_remark": "",
        "l3_remark": "",
        'added_by': authData.user.id
    })
    const navigate = useNavigate();
    const previewHandler = (e) => {
        e.preventDefault();
        setShowPreview(true);
    };
    useEffect(() => {
        fetchDepartments();
        fetchScheme();
    }, [id || viewId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await AddSchemeBankAccount(formData);
            if (response.data.status) {
                toast.success(response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
                navigate('/schemeAccountList');
            } else {
                toast.error(response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            setLoading(false);
        }
    }
    const handleChange = async (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if(name === 'department_id') {
            await fetch_accounts(value);
        }
    }
    const onApprove = async (status) => {
        formData.l2_approval = authData.user.user_type == 'l2' ? status : formData.l2_approval;
        formData.l3_approval = authData.user.user_type == 'l3' ? status : formData.l3_approval;
        let approvalData = {
            l2_approval: formData.l2_approval,
            l3_approval: formData.l3_approval,
            l2_remark: formData.l2_remark,
            l3_remark: formData.l3_remark
        }
        await updateSchemeBankAccountApproval(approvalData, formData.id);
    }
    const fetchDepartments = async () => {
        try {
            setLoading(true);
            const departments = await get_departments({ 
                parent_department_id: authData.user.department_details.id });
            if (departments.data.status) {
                setDepartment(departments.data.result);
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            setLoading(false);
        }
    }
    const fetchScheme = async () => {
        setLoading(true);
        const schemes_list = await get_schemes();
        if (schemes_list.data.status) {
            setScheme(schemes_list.data.schemes);
        }
        setLoading(false);
    }
    const fetch_accounts = async (value) => {
        const accounts = await getSchemeAccountBalances({department_id: value});
        if (accounts.data.status) {
            setAccountList(accounts.data.result);
        }
    }
    const linksArray = [
        { label: "Child Scheme Accounts", href: "/schemeAccountList" },
    ]
    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SchemeAccountPreview showPreview={showPreview} setShowPreview={setShowPreview} formData={formData} handleSubmit={handleSubmit} department={department} scheme={scheme} accounts={accountList}></SchemeAccountPreview>
            <div className="p-3">
                <div className="row">
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Add Scheme Account</h4>
                        <CustomBreadcrumbs linksArray={linksArray} title="Add Scheme Account"/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <button
                                type="button"
                                className="submit_button"
                                onClick={previewHandler}
                                ><span className="fs-14px">Save</span>
                            </button>
                        </div>
                        
                    </div>
                </div>
                <div className="row">
                    <Form onSubmit={previewHandler}>
                        <div className="col-md-12">
                            <div className="card p-3 mt-3">
                                <div className="row">
                                    <Container>
                                        <Row>
                                            <Col md={6} className='mb-3'>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Department *</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        label="Department *"
                                                        id="department_id"
                                                        name='department_id'
                                                        required
                                                        value={formData.department_id || ""}
                                                        onChange={handleChange} 
                                                        readOnly={isReadOnly}
                                                    >
                                                        {department.map((dept) => (
                                                            <MenuItem value={dept.id} key={dept.id}>
                                                                {dept.name} - {dept.code}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Col>
                                            <Col md={6} className='mb-3'>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label2">Scheme *</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label2"
                                                        label="Scheme *"
                                                        id="scheme_id"
                                                        name='scheme_id'
                                                        required
                                                        value={formData.scheme_id || ""}
                                                        onChange={handleChange} 
                                                        readOnly={isReadOnly}
                                                    >
                                                        {scheme.map((dept) => (
                                                            <MenuItem value={dept.id} key={dept.id}>
                                                                {dept.name} - {dept.code}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Col>
                                            <Col md={6} className='mb-3'>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label3">Bank *</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label3"
                                                        label="Bank *"
                                                        id="account_id"
                                                        name='account_id'
                                                        required
                                                        value={formData.account_id || ""}
                                                        onChange={handleChange}
                                                        readOnly={isReadOnly}
                                                    >
                                                        {accountList.map((dept) => (
                                                            <MenuItem value={dept.id} key={dept.id}>
                                                                {dept.account_name} - {dept.account_no}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Col>
                                        </Row>
                                        {
                                            authData.user.user_type == 'l1' ?
                                                <>
                                                    <label>L1 Remark</label>
                                                    <textarea className='form-control' onChange={handleChange} name="l1_remark" readOnly={isReadOnly}></textarea>
                                                </>
                                                : ''
                                        }
                                        <br></br>
                                        {
                                            authData.user.user_type == 'l2' && formData.l2_approval == null ?
                                                <>
                                                    <label>L2 Remark</label>
                                                    <textarea className='form-control' onChange={handleChange} name="l2_remark" readOnly={isReadOnly}></textarea>
                                                    <button type="button" className="btn btn-danger w-30 mt-2" onClick={() => onApprove(0)}>Reject</button>
                                                    <button type="button" className="btn btn-primary w-30 mt-2" style={{ marginLeft: '10px' }} onClick={() => onApprove(1)}>Approve</button>
                                                </>
                                                : ''
                                        }
                                        {
                                            authData.user.user_type == 'l3' && formData.l3_approval == null ?
                                                <>
                                                    <label>L2 Remark</label>
                                                    <textarea className='form-control' onChange={handleChange} name="l3_remark" readOnly={isReadOnly}></textarea>
                                                    <button type="button" className="btn btn-danger w-30 mt-2" onClick={() => onApprove(0)}>Reject</button>
                                                    <button type="button" className="btn btn-primary w-30 mt-2" style={{ marginLeft: '10px' }} onClick={() => onApprove(1)}>Approve</button>
                                                </>
                                                : ''
                                        }
                                    </Container>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
};
export default AddSchemeAccount;